module.exports = __webpack_public_path__ + "img/icon_sun_01.40e48e39.svg";